import { IBrowserAccessor } from '../browser';
import BaseEventModel from '../events/base-event-model';
import { expect } from '../expect';
import { IEventSender } from './event-sender';

export class TrackingPixelEventSender implements IEventSender {
  private readonly cdn: string;
  private readonly browser: IBrowserAccessor;

  /** Initializes a new instance of the TrackingPixelEventSender class. */
  constructor(cdn: string, browser: IBrowserAccessor) {
    this.cdn = expect(cdn).toBeDefined('The CDN is required to initialize TrackingPixelEventSender.');
    this.browser = expect(browser).toBeDefined('The IBrowserAccessor implementation is required to initialize TrackingPixelEventSender.');
  }

  /** Sends event to the provided CDN using Tracking Pixel. */
  public send(event: BaseEventModel): Promise<void> {
    const url = new URL('/client', this.cdn);
    for (const fieldName in event) {
      let value = event[fieldName];
      if (value === null || value === undefined) {
        continue;
      }
      if (value && typeof value === 'object') {
        value = JSON.stringify(value);
      }
      url.searchParams.append(TrackingPixelEventParamsMapper.map(fieldName), value);
    }
    this.browser.createTrackingPixel(url.toString());
    return Promise.resolve();
  }
}

export class TrackingPixelEventParamsMapper {
  public static map(parameterName): string {
    switch (parameterName) {
      case 'eventName':
        return 'e';
      case 'timestamp':
        return 't';
      case 'clientId':
        return 'cid';
      case 'sessionId':
        return 'sid';
      case 'merchantId':
        return 'mid';
      case 'shopperCountryCode':
        return 'scc';
      case 'category':
        return 'c';
      case 'cdn':
        return 'cdn';
      case 'pageUrl':
        return 'p';
      case 'pageTitle':
        return 'pt';
      case 'screenResolution':
        return 'sr';
      case 'userAgent':
        return 'ua';
      case 'referrer':
        return 'ref';
      case 'utmSource':
        return 'utm_source';
      case 'utmMedium':
        return 'utm_medium';
      case 'utmCampaign':
        return 'utm_campaign';
      case 'utmTerm':
        return 'utm_term';
      case 'utmContent':
        return 'utm_content';
      case 'utmAdSet':
        return 'utm_adset';

      default:
        return parameterName;
    }
  }
}
